export class AccesSecurise{
    public token = ''
    public dateEmission = ''
}